export const LayoutHelper = () => {
    return {
        getRootClasses(instituicao, acessibilidade) {
            if (!instituicao && !acessibilidade) return [];
            return [
                'app acessibilidade',
                acessibilidade.cor === 'contraste'
                    ? 'temaAltoContraste alto-contraste'
                    : 'tema-pergamum',//instituicao?.tema?.toLowerCase(),
                acessibilidade.zoom ? `zoom-${acessibilidade.zoom}` : null,
                acessibilidade.negrito ? 'negrito' : null,
                acessibilidade.cor,
            ].join(' ');
        },
    };
};
